export default "https://studio-ui-deployments.apollographql.com/build/static/assets/dev-mock.ae6f1dd48401474ad2b97296d2ce7081.png";